import { render, staticRenderFns } from "./recordExchange.vue?vue&type=template&id=7c35ede2&"
import script from "./recordExchange.vue?vue&type=script&lang=js&"
export * from "./recordExchange.vue?vue&type=script&lang=js&"
import style0 from "./recordExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports